import { ProductizedServiceDurationInput } from '#app/__generated__/api.js';

export const formatProductizedServiceDuration = ({
  amount,
  interval,
}: ProductizedServiceDurationInput) => {
  const intervalLabel = amount === 1 ? interval : `${interval}s`;

  return `${amount} ${intervalLabel.toLowerCase()}`;
};
